import { computed, Ref, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import providers from "@/lib/api";

export default function useTags(selectedTagsSlugs?: Ref<string[]>) {
  const tags = ref<TagInfo[]>([]);

  const tagsBySlug = computed(
    () =>
      (selectedTagsSlugs?.value?.map(slug => tags.value.find(i => i.slug === slug)).filter(i => !!i) as TagInfo[]) ?? []
  );
  const tagsBySlugIds = computed<string[]>(() => tagsBySlug.value.map(tag => tag.id));

  const getTags = async (type?: TagInfoType) => {
    tags.value = await providers.TagsProvider.findAll({ data: { type } });
  };

  return {
    tagsBySlugIds,
    tagsBySlug,
    tags,
    getTags,
  };
}
